import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import compare from "../../assets/icons/fieldPage/compareSlider.svg";

const getBaseBackground = (isActive) =>
  isActive ? "rgba(255, 255, 255, 0.9)" : "rgba(255, 255, 255, 0.667)";

const getHoverBackground = (isActive) =>
  isActive ? "rgba(255, 255, 255, 0.9)" : "rgba(255, 255, 255, 0.9)";

const CustomControl = ({
  isReady,
  position,
  onClick,
  icon = compare,
  activeIcon,
  isActive = false,
  title,
}) => {
  const map = useMap();

  useEffect(() => {
    const container = L.DomUtil.create("img", "leaflet-bar leaflet-control");
    const isCustomIcon = icon !== compare || Boolean(activeIcon);

    container.src = isActive && activeIcon ? activeIcon : icon;
    if (title) {
      container.title = title;
      container.alt = title;
    }
    container.style.backgroundColor = getBaseBackground(isActive);
    container.style.borderRadius = "12px";
    container.style.width = "36px";
    container.style.height = "36px";
    container.style.cursor = isReady ? "pointer" : "default";
    container.style.display = "flex";
    container.style.alignItems = "center";
    container.style.justifyContent = "center";
    if (isCustomIcon) {
      container.style.objectFit = "contain";
      container.style.objectPosition = "center";
      container.style.padding = "4px";
      container.style.boxSizing = "border-box";
      container.style.opacity = isReady ? "1" : "0.45";
    }
    container.style.transition = "background-color 0.3s ease";
    container.addEventListener("mouseover", () => {
      if (isReady) {
        container.style.backgroundColor = getHoverBackground(isActive);
      }
    });

    container.addEventListener("mouseout", () => {
      container.style.backgroundColor = getBaseBackground(isActive);
    });

    if (isReady) {
      container.addEventListener("click", onClick);
    }

    const customControl = L.control({ position });
    customControl.onAdd = () => container;

    customControl.addTo(map);

    return () => {
      // Clean up the control when unmounting
      customControl.remove();
    };
  }, [map, position, isReady, onClick, icon, activeIcon, isActive, title]);

  return null;
};

export default CustomControl;
